import Vue from 'vue';
import accountService from './index';

// When the request succeeds
const success = (data, context) => {
    if (data.msg) {
      context.superCheckin.loading = false;
      toastr.success(data.msg);
      context.closeModal('#configure-super-checkin-modal');
      accountService.fetchAccount(context);
    }
};

// When the request fails
const failed = (error, context) => {
  if (error && error.response && error.response.data && error.response.data.msg) {
    context.superCheckin.loading = false;
    const errorMessages = error.response.data.msg;
    if (typeof errorMessages == 'string') {
      toastr.error(errorMessages);
    } else {
      Object.values(errorMessages).forEach(errorMessage => {
        toastr.error(errorMessage[0]);
      });
    }
  }
};

export default (context, params) => {
  return Vue.$http.post('/sync-super-checkin-locks', params).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context);
    }
  })
    .catch((error) => {
      failed(error,context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/syncSuperCheckin.js